import { API, handleApiError } from "./utils";

export const fetchOrgUsers = async (organisationId) => {
  try {
    const res = await API.get(`/organisations/${organisationId}/users`);
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const changeUserRole = async (organisationId, userId, role) => {
  try {
    const res = await API.patch(
      `/organisations/${organisationId}/users/${userId}/role`,
      { role }
    );
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const removeOrgUser = async (organisationId, userId) => {
  try {
    const res = await API.delete(
      `/organisations/${organisationId}/users/${userId}`
    );
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const sendInvitation = async (organisationId, email, role) => {
  try {
    const res = await API.post(`/organisations/${organisationId}/invitations`, {
      email,
      role,
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchInvitations = async (organisationId) => {
  try {
    const res = await API.get(`/organisations/${organisationId}/invitations`);
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const revokeInvitation = async (organisationId, invitationId) => {
  try {
    const res = await API.delete(
      `/organisations/${organisationId}/invitations/${invitationId}`
    );
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const resendInvitation = async (organisationId, invitationId) => {
  try {
    const res = await API.post(
      `/organisations/${organisationId}/invitations/${invitationId}/resend`
    );
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

// Public endpoints — no auth header needed; they use the shared API instance
// which only adds the header when a token exists in localStorage.
export const fetchInvitationByToken = async (token) => {
  try {
    const res = await API.get(`/invitations/${token}`);
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const acceptInvitation = async (token, password) => {
  try {
    const res = await API.post(`/invitations/${token}/accept`, { password });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};
